import React from 'react'
import './LineSPF.scss'

function GradientLine({
	width = '100%',
	height = '100%',
	data,
	isShowGradientLine,
	isSettings,
	maxEquity,
	minEquity,
	...props
}) {
	const gradientName = 'gradient-equity-scale'
	let offset = 0
	const distance = 100 / data.length

	if (isSettings) {
		return null
	}

	return (
		<>
			{isShowGradientLine ? (
				<div className='line-spf__equity-scale-container'>
					<svg x='0' y='0' width={width} height={height} xmlns='http://www.w3.org/2000/svg' {...props}>
						<defs>
							<linearGradient id={gradientName}>
								{data.map((item) => {
									offset += distance

									return <stop key={`${item.value}`} offset={`${offset}%`} stopColor={item.color} />
								})}
							</linearGradient>
						</defs>
						<rect width={width} height={height} fill={`url('#${gradientName}')`} />
					</svg>

					<div className='line-spf__values-container'>
						<span className='line-spf__min-value'>{minEquity}</span>
						<span className='line-spf__max-value'>{maxEquity}</span>
					</div>
				</div>
			) : (
				<div className='line-spf__nodata-container'>
					<span>No data</span>
				</div>
			)}
		</>
	)
}

export default GradientLine
